
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'SectionMyResume',
  components: {},
  data() {
    return {
      link: require('@/assets/pdf/João Vitor da Silva Monteiro.pdf'),
    }
  },
  methods: {
    generateDownloadLink() {
      fetch(this.link.default)
          .then(response => {
            return response.blob()
          })
          .then(blob => {
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Currículo João Vitor da Silva Monteiro.pdf');
            document.body.appendChild(link);
            link.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
          })
          .catch(error => {
            console.error('Erro ao baixar o PDF:', error);
          });
    }
  }
});
